const DEFAULT_SETTINGS = {
    irrigationMode: null,
    waterSavingMode: true,
    bestGrowingMode: false,
    vacationMode: false,
    workingMode: false,
    wateringTime: 'sunset',
    wateringTimeAt: null,
    maxWateringTime: 0,
    wateringDuration: null,
    notifyContactPerson: false,
    contactPersonMail: '',
    emailNotifications: false,
    emailAddress: '',
    vacationNotifications: false,
    frostWarnings: true,
    notificationMoistureLow: true,
    notificationMoistureHigh: true,
}

export const wateringTimeOptions = [
    {
        value: 'sunset',
        label: 'Sonnenuntergang',
    },
    {
        value: 'sunrise',
        label: 'Sonnenaufgang',
    },
    {
        value: 'specific-time',
        label: 'Bestimmte Zeit',
    },
]

export const generalModeOptions = [
    {
        value: 'automatic',
        label: 'Automatisch',
    },
    {
        value: 'winter',
        label: 'Winter',
    },
    {
        value: 'party',
        label: 'Party',
    },
    {
        value: 'reactive',
        label: 'Reactiv',
    },
    {
        value: 'manual',
        label: 'Manuell',
    },
    {
        value: 'time-scheduled',
        label: 'Zeit-basiert',
    },
]

export default DEFAULT_SETTINGS



// WEBPACK FOOTER //
// ./src/constants/settings.js